import React from 'react';
import './KilobaCard.css';

interface KilobaCardProps {
  kilobaType: string; // Tên loại kiloba
  kilobaCode: string; // Mã kiloba để map với ảnh
  quantity: number; // Số lượng
  onClick?: () => void; // Optional click handler
}

const KilobaCard: React.FC<KilobaCardProps> = ({
  kilobaType,
  kilobaCode,
  quantity,
  onClick
}) => {
  // Map kiloba code to image path
  const getKilobaImagePath = (code: string): string => {
    const kilobaImages: { [key: string]: string } = {
      'kiloba_banker': '/images/kilohub/kiloba_banker.png',
      'kiloba_conne_x': '/images/kilohub/kiloba_conne_x.png',
      'kiloba_fin': '/images/kilohub/kiloba_fin.png',
      'kiloba_toannang': '/images/kilohub/kiloba_toannang.png',
      'kiloba_trust': '/images/kilohub/kiloba_trust.png',
      'kiloba_viet': '/images/kilohub/kiloba_viet.png'
    };
    
    return kilobaImages[code] || '/images/kilohub/kiloba_banker.png'; // Default fallback
  };

  const handleCardClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={`kiloba-card ${quantity === 0 ? 'kiloba-card-disabled' : ''}`} onClick={handleCardClick}>
      <div className="kiloba-card-background" style={{ 
        backgroundImage: `url('${getKilobaImagePath(kilobaCode)}')` 
      }}>
        {/* Số lượng ở góc trên bên phải */}
        
        
        {/* Ảnh kiloba ở giữa, cách đáy 50px */}
        {/* <div className="kiloba-image-container-card">
          <img 
            src={getKilobaImagePath(kilobaCode)} 
            alt={kilobaType}
            className="kiloba-image"
          />
        </div> */}
        
        {/* Tên loại kiloba ở bottom, căn giữa */}
        {/* <div className="kiloba-type">
          {kilobaType}
        </div> */}
      </div>
    </div>
  );
};

export default KilobaCard;
